/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/api-v2-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { FragmentsStartFragmentMediaRegenerationMutationResponse, FragmentsStartFragmentMediaRegenerationPathParams } from "../models/FragmentsStartFragmentMediaRegeneration";

export function getFragmentsStartFragmentMediaRegenerationUrl(fragmentId: FragmentsStartFragmentMediaRegenerationPathParams["fragmentId"]) {
  const res = { method: 'POST', url: `/fragments/${fragmentId}/regenerate-media` as const }
  return res
}

/**
 * @summary Regenerate fragment media assets
 * {@link /fragments/:fragmentId/regenerate-media}
 */
export async function fragmentsStartFragmentMediaRegeneration(fragmentId: FragmentsStartFragmentMediaRegenerationPathParams["fragmentId"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<FragmentsStartFragmentMediaRegenerationMutationResponse, ResponseErrorConfig<Error>, unknown>({ method : "POST", url : getFragmentsStartFragmentMediaRegenerationUrl(fragmentId).url.toString(), ... requestConfig })
  return res.data
}